<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">SVIP用户管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>城市：</label>
          <Area title="" @areaChang='getArea($event)' :reset="resetArea"/>
        </div>
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em" @change="updateObj">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>套餐项目：</label>
          <el-select v-model="marriageId" placeholder="Select" style="width: 10em">
            <el-option v-for="item in marriageList" :key="item.id" :label="item.name + (item.sex == 1?'：男':item.sex == 2?'：女':'')  + (item.state == 0?'（待上架）':item.state == 1?'（上架中）':item.state == 2?'（已下架）':'')" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>订阅状态：</label>
          <el-select v-model="userSignedState" placeholder="请选择" size="mini" style="width: 6em;">
            <el-option v-for="item in userSignedStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>支付方式：</label>
          <el-select v-model="svipPayMode" placeholder="请选择" size="mini" style="width: 6em;">
            <el-option v-for="item in svipPayModeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>开通类型：</label>
          <el-select v-model="svipPayType" placeholder="请选择" size="mini" style="width: 6em;">
            <el-option v-for="item in svipPayTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>套餐状态：</label>
          <el-select v-model="marriageState" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in marriageStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <label>到期状态：</label>-->
<!--          <el-select v-model="expireType" placeholder="Select" style="width: 6.4em">-->
<!--            <el-option v-for="item in expireTypeArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="content-input-item">
          <label>SVIP获取方式：</label>
          <el-select v-model="obtainMethod" placeholder="Select" style="width: 8em">
            <el-option v-for="item in obtainMethodArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>开通次数：</label>
          <el-select v-model="openNum" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in openNumArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="生日时间：" @date="getBirthTime($event)" @check="getBirthCheck($event)" :isChecked="isBirthChecked" :startTime="birthdayStartTime" :endTime="birthdayEndTime" :shortcuts="defaultList"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
          <SearchUidOrPhone style="margin-right: 16px;" @confirm="openDialog($event)" :type="3"/>
          <el-input v-model="searchBillValue" placeholder="请输入订单号" clearable style="width: 20em"/>
          <el-button style="margin-left: 8px;" type="success" @click="getSearchBill" v-loading="searchBillLoading"> 查询 </el-button>
<!--          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>-->
<!--          <el-button type="success" v-loading="updateLoading" @click="batchUpdate(2)">批量通过</el-button>-->
<!--          <el-button type="danger" v-loading="updateLoading" @click="batchUpdate(3)">批量不通过</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            v-loading="listLoading"
        >
<!--          <el-table-column type="selection" width="40" align="center" class-name="cursor"/>-->
          <el-table-column property="updateTime" label="开通时间" v-if="checkColList.indexOf('开通时间') > -1"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="106">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,birth"/>
              <p>现居城市：{{scope.row.city}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="SVIP记录" v-if="checkColList.indexOf('SVIP记录') > -1" class-name="cursor" width="300">
            <template #default="scope">
              <MarriageLog :user-log-list="scope.row.marriageDtList" />
            </template>
          </el-table-column>
          <el-table-column property="paySum" label="现金支付" v-if="checkColList.indexOf('现金支付') > -1">
            <template #default="scope">
              <p v-if="scope.row.billSumStat">{{ scope.row.billSumStat.paySum }}</p>
            </template>
          </el-table-column>
          <el-table-column property="voucherSum" label="代金券" v-if="checkColList.indexOf('代金券') > -1">
            <template #default="scope">
              <p v-if="scope.row.billSumStat">{{ scope.row.billSumStat.voucherSum }}</p>
            </template>
          </el-table-column>
          <el-table-column property="expireDay" label="SVIP剩余时间" v-if="checkColList.indexOf('SVIP剩余时间') > -1">
            <template #default="scope">
              <span v-if="scope.row.svipState == 2">终身SVIP</span>
              <p v-if="scope.row.expireDay">{{ scope.row.expireDay }}天</p>
            </template>
          </el-table-column>
<!--          <el-table-column prop="" label="牵线服务" v-if="checkColList.indexOf('牵线服务') > -1">-->
<!--            <template #default="scope">-->
<!--              <p>{{ scope.row.matcherFinishNum }}/{{ scope.row.matcherNum }}</p>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              <p>{{ scope.row.state == 1 ? '正常' : scope.row.state == 2 ? '已解除' : scope.row.state == 3 ? '已过期' : '' }}</p>
            </template>
          </el-table-column>
          <el-table-column property="openNum" label="开通次数" v-if="checkColList.indexOf('开通次数') > -1"/>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space direction="vertical" alignment="left">
                <el-button type="danger" size="small" @click="updateReState(scope.$index, scope.row, 1)" v-loading="scope.row['reLoading']">解除服务</el-button>
              </el-space>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="180">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
  getMarriagePageUserList, getMarriageAllList,
  updateMarriageUserExpire, getSearchBillInfo
} from '../../api/url'
import {getFormData, postFormData} from '@/api/api'
import Dialog from '../../assets/js/dialog'
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import { common } from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import MarriageLog from "@/components/MarriageLog/MarriageLog";
import MarriageLogDialog from "@/components/MarriageLog/MarriageLogDialog";
import SendSystemMessageChat from "@/components/SendSystemMessageChat";
import SearchUidOrPhone from '../../components/SearchUidOrPhone'
import ExpireUserSearchInfoDialog from "@/views/marriage/components/ExpireUserSearchInfoDialog";
import SearchBillInfoDialog from "@/views/vip/components/SearchBillInfoDialog";
import Area from '@/components/AreaSelectSvip'

export default {
  name: "MarriageExpire",
  components: { DatePickerRange, SearchComponents, UserLog, MarriageLog, SearchUidOrPhone, Area },
  data() {
    return {

      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      //套餐类型
      marriageList: [
        {name: "不限", id: 0}
      ],
      marriageId: 0,
      marriageObj: [],
      marriageManObj: [],
      marriageWomObj: [],

      //套餐状态
      marriageStateArray: [
        {label: "不限", value: -1},
        {label: "上架中", value: 1},
        {label: "已下架", value: 2}
      ],
      marriageState: 1,

      //状态
      stateArray: [
        {label: "不限", value: -1},
        {label: "正常", value: 1},
        {label: "已解除", value: 2},
        {label: "已过期", value: 3},
      ],
      state: -1,

      //订阅状态
      userSignedStateArray: [
        {label: "不限", value: -1},
        {label: "未订阅", value: 0},
        {label: "订阅中", value: 1},
        {label: "购买后取消", value: 2},
        {label: "购买中取消", value: 3},
      ],
      userSignedState: -1,


      //支付方式
      svipPayModeArray: [
        {label: "不限", value: -1},
        {label: "支付宝", value: 1},
        {label: "微信", value: 2}
      ],
      svipPayMode: -1,


      //开通类型
      svipPayTypeArray: [
        {label: "不限", value: -1},
        {label: "普通类型", value: 1},
        {label: "订阅类型", value: 2},
        {label: "续费成功", value: 3},
      ],
      svipPayType: -1,

      // //到期状态
      // expireTypeArray: [
      //   {label: "不限", value: -1},
      //   {label: "未过期", value: 1},
      //   {label: "已过期", value: 2}
      // ],
      // expireType: 1,

      obtainMethodArray: [
        {label: "不限", value: -1},
        {label: "充值购买", value: 0},
        {label: "后台赠送", value: 1},
        {label: "0元体验", value: 2},
        {label: "邀请制赠送", value: 3}
      ],
      obtainMethod: -1,

      openNumArray: [
        {label: "不限", value: 0},
        {label: "1", value: 1},
        {label: "2", value: 2},
        {label: "3", value: 3},
        {label: "4", value: 4},
        {label: "5", value: 5},
        {label: "6", value: 6},
        {label: "7", value: 7},
        {label: "8", value: 8},
        {label: "9", value: 9},
        {label: "10", value: 10},
        {label: "10次以上", value: 11}
      ],
      openNum: 0,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //生日时间
      birthdayStartTime: '',
      birthdayEndTime: '',
      isBirthChecked: true,

      defaultList: [
        {
          text: '20-30岁',
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 30);
            end.setFullYear(end.getFullYear() - 20);
            return [start, end]
          }
        },
        {
          text: '30-40岁',
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 40);
            end.setFullYear(end.getFullYear() - 30);
            return [start, end]
          }
        },
        {
          text: '40-50岁',
          value: () => {
            const end = new Date();
            const start = new Date();
            start.setFullYear(start.getFullYear() - 50);
            end.setFullYear(end.getFullYear() - 40);
            return [start, end]
          }
        }
      ],


      //搜索
      searchType: '',
      searchValue: '',

      //刷新组
      colList: ['开通时间', '头像', '用户信息', 'SVIP记录', '现金支付', '代金券', 'SVIP剩余时间', '牵线服务', '状态', '开通次数', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      dataSummary: [],

      idArray: [],
      updateLoading: false,

      //查询订单号
      searchBillValue: '',
      searchBillLoading: false,

      province: '',
      city: '',
      resetArea: false

    }
  },
  methods: {

    // 现居城市
    getArea(el) {
      // console.log(el)
      this.province = el.prov;
      this.city = el.city != '不限'?el.city:'';
      // if(this.homeCity != '' && this.homeCity != null && this.homeCity != '不限'){
      //   let c = this.selectCitys.indexOf(this.homeCity);
      //   if(c == -1){
      //     this.selectCitys.push(this.homeCity)
      //     this.submitCity()
      //   }else{
      //     this.$message({
      //       message: '你已经添加了改城市',
      //       type: "error"
      //     });
      //   }
      // }
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getBirthTime(val) {
      this.birthdayStartTime = val[0];
      this.birthdayEndTime = val[1];
      // console.log(val)
    },
    getBirthCheck(val) {
      this.isBirthChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.resetArea = true
      this.isChecked = true;
      this.isBirthChecked = true;
      this.sex = -1;
      this.marriageId = 0;
      this.marriageState = 1;
      this.state = -1;
      this.expireType = 1;
      this.obtainMethod = -1;
      this.userSignedState = -1;
      this.svipPayMode = -1;
      this.svipPayType = -1;
      this.openNum = 0;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['marriageId'] = this.marriageId;
      param['marriageState'] = this.marriageState;
      param['state'] = this.state;
      // param['expireType'] = this.expireType;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['birthdayStartTime'] = this.birthdayStartTime;
      param['birthdayEndTime'] = this.birthdayEndTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['obtainMethod'] = this.obtainMethod;
      param['openNum'] = this.openNum;
      param['userSignedState'] = this.userSignedState;
      param['svipPayMode'] = this.svipPayMode;
      param['svipPayType'] = this.svipPayType;
      param['province'] = this.province;
      param['city'] = this.city;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMarriagePageUserList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      //婚恋服务购买记录
      if(column.label == 'SVIP记录') {
        Dialog.open({
          title: 'SVIP记录',
          component: MarriageLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
          }
        })
      }

    },

    //解除
    updateReState(idx, row) {
      this.$confirm('确定解除'+'【' + row.nickName + '】的婚恋服务吗？').then(()=>{
        this.pageDataList[idx]['reLoading'] = true
        let param = {}
        param['id'] = row.userId
        param['day'] = 0
        param['type'] = 0
        postFormData(updateMarriageUserExpire, param).then((data)=>{
          let {code, msg} = data
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            })
            this.pageDataList.splice(idx, 1)
          }else {
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          this.pageDataList[idx]['reLoading'] = false
        }).catch(()=>{
          this.pageDataList[idx]['reLoading'] = false
        })
      })
    },

    //搜索
    openDialog(e) {
      // console.log(e)
      Dialog.open({
        component: ExpireUserSearchInfoDialog,
        data: {
          userForm: e,
          idx: -1,
          width: '600px'
        },
        confirm: () => {
          this.getPage()
        }
      })
    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessageChat,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    getDefault(year) {
      let d = new Date();
      d.setFullYear(d.getFullYear() - year);
      return d.getFullYear() + "-" + (d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1) + "-" + (d.getDate() < 10 ? '0' + d.getDate() : d.getDate());
    },

    getObj() {
      let _this = this;
      getFormData(getMarriageAllList, {}).then((data) => {
        let {code, msg} = data;
        if (code == 200) {
          _this.marriageObj = data.data;
          _this.marriageObj.map(item => {
            if(item.sex == 1) {
              _this.marriageManObj.push(item)
            } else if(item.sex == 2) {
              _this.marriageWomObj.push(item)
            }
          })
          _this.updateObj();
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },
    updateObj() {
      this.marriageList = [
        {name: "不限", id: 0}
      ]
      if (this.sex == -1) {
        this.marriageList = this.marriageList.concat(this.marriageObj);
      } else if (this.sex == 1) {
        this.marriageList = this.marriageList.concat(this.marriageManObj);
      } else if (this.sex == 2) {
        this.marriageList = this.marriageList.concat(this.marriageWomObj);
      }
      this.marriageId = this.marriageList[0]['id'];
    },


    getSearchBill() {
      if(!this.searchBillValue) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '订单号不能为空',
          type: 'warning'
        });
        return;
      }
      this.searchBillLoading = true
      let param = {};
      param['searchValue'] = this.searchBillValue;
      getFormData(getSearchBillInfo, param).then((data)=> {
        let {code, msg} = data;
        if (code == 200) {
          // console.log(data)
          Dialog.open({
            component: SearchBillInfoDialog,
            data: {
              userForm: data.data,
              width: '600px'
            },
            confirm: () => {
              // this.getPage()
            }
          })
        } else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchBillLoading = false
      })
    }


  },
  created() {
    this.birthdayEndTime = this.getDefault(18);
    this.birthdayStartTime = this.getDefault(20);
  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getObj();
  }
}
</script>

<style scoped>

</style>
